import { Draft } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

function createFailure(draft: Draft<IUserData>) {
  draft.create.config.isLoading = false;
}

export default createFailure;
